var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegalAdviceBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 190,
    viewBox: "0 0 240 190",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8 0 L 232 0 C 236.418274 0 240 3.581726 240 8 L 240 182 C 240 186.418274 236.418274 190 232 190 L 8 190 C 3.581722 190 0 186.418274 0 182 L 0 8 C 0 3.581726 3.581722 0 8 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1",
    clipPath: "url(#clipPath1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fill: "#ffffff",
    stroke: "none",
    d: "M 8 0 L 232 0 C 236.418274 0 240 3.581726 240 8 L 240 182 C 240 186.418274 236.418274 190 232 190 L 8 190 C 3.581722 190 0 186.418274 0 182 L 0 8 C 0 3.581726 3.581722 0 8 0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1",
    fill: "#8484f6",
    stroke: "none",
    d: "M 169.507996 157.679001 C 109.275002 194.179993 60.692699 187.080994 43.966099 191.278 L 118.872002 235.514999 L 354.906006 216.531998 L 336.891998 96.001404 C 331.253998 92.431 297.160004 80.146301 262.572998 83.686096 C 219.339005 88.110901 235.848999 117.477997 169.507996 157.679001 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2",
    fill: "#205497",
    stroke: "none",
    d: "M 99.661003 14.610901 C 164.628998 -12.585693 211.628006 1.617233 228.791 -0.061417 L 161.246994 -54.884903 L -74.999901 -70.999908 L -74.999901 50.869797 C -69.951897 55.234406 -38.048401 72.423599 -3.318085 74.035103 C 40.094799 76.0495 28.107 44.564896 99.661003 14.610901 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalAdviceBg);
export default __webpack_public_path__ + "static/media/legal-advice-bg.3241bdff7a3db6e342508f0c27f274b7.svg";
export { ForwardRef as ReactComponent };